import DOMPurify from 'dompurify';
import { decodeHtmlEntities } from '~/helpers/propertyDescription';
import { escapeHtml } from '~/utils/escapeHtml';

/**
 * Sanitize stored/third-party HTML before `v-html`. DOMPurify needs a DOM, so on the
 * server (no `window`) this returns '' — callers render sanitized HTML after mount.
 */
export const sanitizeHtml = (html: string): string => {
  if (typeof window === 'undefined' || !DOMPurify.isSupported) return '';
  return DOMPurify.sanitize(html);
};

/**
 * The SSR / pre-mount stand-in for `sanitizeHtml`: the HTML's text only (script/style blocks and
 * tags dropped, whitespace collapsed, entities decoded), escaped so it is safe for `v-html`. Keeps
 * the content in the server HTML for SEO until the sanitized HTML replaces it after mount.
 */
export const htmlToSsrSafeHtml = (html: string): string =>
  escapeHtml(
    decodeHtmlEntities(
      html
        .replace(/<(script|style)\b[\s\S]*?<\/\1\s*>/gi, ' ')
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim(),
    ),
  );
